import React from "react";
import i18n from "i18next";
import PropTypes from "prop-types";
import { withSitecoreContext } from "@sitecore-jss/sitecore-jss-react";
import moment from "moment";

import LPMain from "@/react-components/LPMain";
import BackButton from "@/react-components/BackButton";
import MainDetail from "@/react-components/MainDetail";

class NewsReleaseDetail extends React.Component {
  render() {
    const {
      data,
      props,
      children,
      sitecoreContext: {
        route: { fields },
      },
    } = this.props;
    return (
      <LPMain className="lp-news-detail-container">
        <div className="lp-news-detail-container-title">
          {i18n.t("TCLs0030_lp_news_detail_notifiction_title")}
        </div>
        <div className="lp-news-detail-container-content">
          <BackButton />
          <div className="lp-news-detail-container-content-title">
            {fields?.title?.value}
          </div>
          <div className="lp-news-detail-container-content-date">
            {moment(fields?.publicDate?.value)
              .utcOffset(9)
              .format("yyyy.MM.DD")}
          </div>
          <MainDetail
            data={data}
            props={props}
            showRelated={false}
            showEvaluate={false}
          >
            {children}
          </MainDetail>
        </div>
      </LPMain>
    );
  }
}

NewsReleaseDetail.propTypes = {
  data: PropTypes.array.isRequired,
  props: PropTypes.object.isRequired,
};

export default withSitecoreContext()(NewsReleaseDetail);
